module.exports = __webpack_public_path__ + "static/img/female2-01.3bf51bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/female2-01.jpg
// module id = 269
// module chunks = 1